import { ComputedRef, inject } from "vue";
import { Pool } from "@/models/pool.model";

export const usePool = () =>
  (inject("pool") as ComputedRef<Pool>)?.value as Pool;

export const useSavePool = () =>
  inject("savePool") as (forceOutState?: boolean) => Promise<void>;
